(function () {
  const storeId = '114176';
  const skuToCode = {
    '\'1009': '352579447',
    '\'1022': '401170015',
    '\'10360702': '342887619',
    '\'1069': '400377016',
    '\'10716': '377831204',
    '\'11097': '399991100',
    '\'112242': '266409581',
    '\'112658': '382483519',
    '\'113184': '297496983',
    '\'113568': '326644053',
    '\'113569': '297479522',
    '\'113570': '297107367',
    '\'113571': '297121775',
    '\'113572': '297084770',
    '\'1146': '291804647',
    '\'11587': '400037178',
    '\'11590': '400031156',
    '\'116237': '379851252',
    '\'116305': '326620242',
    '\'11633': '374937539',
    '\'11640': '374923898',
    '\'116626': '401783823',
    '\'11702': '374929699',
    '\'11707': '399947236',
    '\'11708': '382769016',
    '\'11862': '374940622',
    '\'1214': '401609741',
    '\'1218': '401649488',
    '\'1219': '401617814',
    '\'1239': '289558388',
    '\'1268': '285425643',
    '\'129': '345391245',
    '\'131': '345397387',
    '\'1315': '370397011',
    '\'138': '345404365',
    '\'14001': '269383557',
    '\'1620': '380014210',
    '\'1621': '377443202',
    '\'1623': '363078315',
    '\'1624': '399570535',
    '\'1625': '362937614',
    '\'1626': '362981016',
    '\'1627': '400368591',
    '\'1628': '399570762',
    '\'1629': '399575414',
    '\'1630': '370956459',
    '\'1631': '370858732',
    '\'1632': '363460286',
    '\'1635': '381353113',
    '\'1636': '393291096',
    '\'1637': '400362220',
    '\'2106': '401082697',
    '\'2107': '401106522',
    '\'2108': '401113622',
    '\'2109': '401118004',
    '\'2110': '400324423',
    '\'2112': '401139650',
    '\'2114': '401140722',
    '\'2116': '401130735',
    '\'2119': '400338075',
    '\'2221': '276187279',
    '\'2223': '276185771',
    '\'2573': '370404515',
    '\'2659': '370387543',
    '\'26952': '345254718',
    '\'2783': '400512389',
    '\'30934': '278469943',
    '\'31086': '264104942',
    '\'31308': '282219929',
    '\'31363': '264826387',
    '\'31548': '343028157',
    '\'31654': '282213490',
    '\'31657': '264104802',
    '\'31804': '264105150',
    '\'31805': '282214032',
    '\'31832': '264103811',
    '\'31849': '264103086',
    '\'31859': '264103442',
    '\'31860': '281040793',
    '\'31863': '264105123',
    '\'31864': '282213305',
    '\'31954': '264825224',
    '\'3200': '263374431',
    '\'3202': '263374414',
    '\'32159': '343036783',
    '\'32239': '343062271',
    '\'32240': '264102987',
    '\'356': '370533282',
    '\'3766': '400508105',
    '\'4080': '266909243',
    '\'4124': '259822582',
    '\'4176': '267168873',
    '\'4220': '399779232',
    '\'4224': '262761708',
    '\'4225': '262761788',
    '\'4226': '262761775',
    '\'4227': '262761746',
    '\'4228': '259822594',
    '\'4230': '259822585',
    '\'45028': '267157585',
    '\'45029': '267156943',
    '\'45055': '265935862',
    '\'493': '267175551',
    '\'5006': '399773799',
    '\'5248': '263377531',
    '\'5446': '370347749',
    '\'5513': '374898942',
    '\'5518': '281130058',
    '\'5520': '282012670',
    '\'5529': '374902230',
    '\'5559': '374933773',
    '\'5579': '399995331',
    '\'5604': '400033806',
    '\'5609': '399945261',
    '\'5618': '400050508',
    '\'5621': '399997184',
    '\'5754': '370408492',
    '\'60021': '266903642',
    '\'60022': '266411552',
    '\'60023': '269151278',
    '\'60029': '266911809',
    '\'60030': '266911589',
    '\'60063': '263038908',
    '\'60070': '263038905',
    '\'60074': '263038900',
    '\'64009': '281154044',
    '\'65585': '375667684',
    '\'66632': '274145277',
    '\'67305': '278815200',
    '\'698': '264848922',
    '\'797': '370377777',
    '\'80120': '263375495',
    '\'80220': '263377496',
    '\'8038': '400041520',
    '\'8046': '399984774',
    '\'8048': '399954214',
    '\'81196': '263229822',
    '\'890': '345841756',
    '\'891': '345823242',
    '\'892': '345847525',
    '\'898': '345881829',
    '\'899': '345878647',
    '\'9012': '263377371',
    '\'90120': '263376316',
    '\'90220': '263377516',
    '\'9108': '263375806',
    '\'9112': '263377486',
    '\'9297': '263373139',
    '\'94060': '375203451',
    '\'94070': '375061327',
    '\'952': '400389815',
    '\'953': '400392846',
    '\'954': '345832438',
    '\'955': '345835784',
    '1009': '352579447',
    '1020c': '263375572',
    '1022': '401170015',
    '10360702': '342887619',
    '1069': '400377016',
    '10716': '377831204',
    '11097': '399991100',
    '112242': '266409581',
    '112658': '382483519',
    '113184': '297496983',
    '113568': '326644053',
    '113569': '297479522',
    '113570': '297107367',
    '113571': '297121775',
    '113572': '297084770',
    '1146': '291804647',
    '11587': '400037178',
    '11590': '400031156',
    '116237': '379851252',
    '116305': '326620242',
    '11633': '374937539',
    '11640': '374923898',
    '116626': '401783823',
    '11702': '374929699',
    '11707': '399947236',
    '11708': '382769016',
    '11862': '374940622',
    '12007prd': '263288669',
    '1214': '401609741',
    '1218': '401649488',
    '1219': '401617814',
    '1239': '289558388',
    '1268': '285425643',
    '129': '345391245',
    '131': '345397387',
    '1315': '370397011',
    '138': '345404365',
    '14001': '269383557',
    '16002pt': '269378621',
    '1620': '380014210',
    '1621': '377443202',
    '1623': '363078315',
    '1624': '399570535',
    '1625': '362937614',
    '1626': '362981016',
    '1627': '400368591',
    '1628': '399570762',
    '1629': '399575414',
    '1630': '370956459',
    '1631': '370858732',
    '1632': '363460286',
    '1635': '381353113',
    '1636': '393291096',
    '1637': '400362220',
    '2106': '401082697',
    '2107': '401106522',
    '2108': '401113622',
    '2109': '401118004',
    '2110': '400324423',
    '2112': '401139650',
    '2114': '401140722',
    '2116': '401130735',
    '2119': '400338075',
    '2221': '276187279',
    '2223': '276185771',
    '23kf': '383620232',
    '23kfloral': '262764445',
    '2573': '370404515',
    '2659': '370387543',
    '26952': '345254718',
    '2783': '400512389',
    '3000ctx': '260991191',
    '30934': '278469943',
    '31086': '264104942',
    '31308': '282219929',
    '31363': '264826387',
    '31548': '343028157',
    '31654': '282213490',
    '31657': '264104802',
    '31804': '264105150',
    '31805': '282214032',
    '31832': '264103811',
    '31849': '264103086',
    '31859': '264103442',
    '31860': '281040793',
    '31863': '264105123',
    '31864': '282213305',
    '31954': '264825224',
    '3200': '263374431',
    '3202': '263374414',
    '32159': '343036783',
    '32239': '343062271',
    '32240': '264102987',
    '356': '370533282',
    '3766': '400508105',
    '40062az': '268585495',
    '40062pt': '268528004',
    '40067az': '268587812',
    '40067pt': '268582894',
    '40155az': '380144614',
    '40155pt': '356358338',
    '4080': '266909243',
    '4124': '259822582',
    '4176': '267168873',
    '4220': '399779232',
    '4224': '262761708',
    '4225': '262761788',
    '4226': '262761775',
    '4227': '262761746',
    '4228': '259822594',
    '4230': '259822585',
    '45028': '267157585',
    '45029': '267156943',
    '45055': '265935862',
    '493': '267175551',
    '5006': '399773799',
    '5248': '263377531',
    '5446': '370347749',
    '5513': '374898942',
    '5518': '281130058',
    '5520': '282012670',
    '5529': '374902230',
    '5559': '374933773',
    '5579': '399995331',
    '5604': '400033806',
    '5609': '399945261',
    '5618': '400050508',
    '5621': '399997184',
    '5754': '370408492',
    '5760': '403609896',
    '60021': '266903642',
    '60022': '266411552',
    '60023': '269151278',
    '60029': '266911809',
    '60030': '266911589',
    '60060az': '403538166',
    '60060pt': '403566077',
    '60060vm': '403566075',
    '60063': '263038908',
    '60070': '263038905',
    '60074': '263038900',
    '60077': '265933746',
    '626gprv': '368597625',
    '64009': '281154044',
    '65585': '375667684',
    '6571': '403718044',
    '6572': '403568299',
    '66632': '274145277',
    '67305': '278815200',
    '698': '264848922',
    '797': '370377777',
    '80120': '263375495',
    '80220': '263377496',
    '8038': '400041520',
    '8046': '399984774',
    '8048': '399954214',
    '81196': '263229822',
    '890': '345841756',
    '891': '345823242',
    '892': '345847525',
    '898': '345881829',
    '899': '345878647',
    '9012': '263377371',
    '90120': '263376316',
    '90220': '263377516',
    '91017az': '266409734',
    '91018az': '266908347',
    '9108': '263375806',
    '9112': '263377486',
    '9297': '263373139',
    '9355kit': '263377702',
    '94060': '375203451',
    '94070': '375061327',
    '952': '400389815',
    '953': '400392846',
    '954': '345832438',
    '955': '345835784',
    'a5514': '400079524',
    'acm0822vp': '263288779',
    'acm48bp': '263288633',
    'acm48pp': '263288595',
    'acm8007nprd': '263288725',
    'acm8007pbk': '263288754',
    'ad-18': '399880543',
    'ad18bks': '334642713',
    'af1': '268679254',
    'ap-550bk': '300311701',
    'ap-550bn': '401731143',
    'ap-550we': '401723058',
    'ap-s450bk': '300347480',
    'ap-s450bn': '401760934',
    'ap-s450we': '401749827',
    'ap300bg': '397363799',
    'ap300bgf': '397377410',
    'ap300bk': '351296540',
    'ap300bkf': '351398156',
    'ap300bn': '351403725',
    'ap300bnf': '351407772',
    'ap300we': '351423857',
    'ap300wef': '351433493',
    'ap750bg': '397416124',
    'ap750bk': '275885218',
    'ap750bn': '397656284',
    'ap750we': '397416063',
    'aps200bk': '351197645',
    'aps200bkb': '351200342',
    'aps200bkbf': '351203015',
    'aps200bn': '351209459',
    'aps200bnb': '351218107',
    'aps200bnbf': '351224148',
    'aps200we': '351267163',
    'aps200web': '351275358',
    'aps200webf': '351282753',
    'aps450bkb7': '403599842',
    'aps450bn': '402060059',
    'aps450bnb7': '403599758',
    'aps450web7': '403599801',
    'atrium12': '358471384',
    'axios16': '342802005',
    'b20x14': '400149982',
    'b22x14': '400150343',
    'b24x14': '400150616',
    'b26x14': '400150829',
    'bal1508mgprv': '368593245',
    'bm514nmr': '281124363',
    'bm607n': '359831124',
    'bmm700': '359754393',
    'bss150': '263223487',
    'bss180': '263223518',
    'bss400': '310055279',
    'bss500': '263223503',
    'c103l': '400708234',
    'capabumbo': '266903963',
    'capapianocasio': '267453304',
    'caparepique': '266408266',
    'capasurdo30': '266904140',
    'capasurdo45': '266903402',
    'car4': '263377429',
    'cb-30bk': '267451191',
    'cb60': '263048185',
    'cdp-s110': '399735510',
    'cdps110': '264164798',
    'cdps110wh': '331634043',
    'cdps110whs': '331833792',
    'cdps160': '257799870',
    'cdps160cs46banqueta': '257801496',
    'cdps360': '257802170',
    'cfm-14200': '266407079',
    'chs-0100': '266407289',
    'chs-b21400': '266407563',
    'cjretro': '399911664',
    'ck8sinos': '311422455',
    'click-4': '382927650',
    'cmpas100': '274443590',
    'cmx4livebk': '263967683',
    'cpf': '269114917',
    'cs-90bk': '265458588',
    'cs46': '264317674',
    'cs470p': '265758074',
    'cs68': '267482813',
    'ct-x800': '260979639',
    'ct-x800rt': '402074061',
    'ctk3500kit': '260981588',
    'ctk3500kit2': '260982329',
    'ctk3500pedal1': '260984183',
    'cts1': '262944716',
    'cts1rd': '262964881',
    'cts200bk': '262755835',
    'cts200rd': '262773416',
    'cts200wh': '262919813',
    'cts300spc': '399986183',
    'cts400': '263350610',
    'cts500bk': '263352586',
    'ctx3000kit': '260991995',
    'dbh-01n': '398822882',
    'dbh01l': '398821130',
    'delphi-01': '263952169',
    'dhx670c': '375811822',
    'drumbox-pratos-2': '267426576',
    'e483': '285135563',
    'e483c': '395152983',
    'e483cp': '395185449',
    'e483cs': '395170295',
    'e483ps': '395193255',
    'e483s': '395197648',
    'e483scp': '395175447',
    'earth60m': '399899056',
    'earth60mf': '399903239',
    'escaleta32': '263373765',
    'escaleta32ap': '263373752',
    'escaleta32pb': '263373792',
    'escaleta37ab': '263373731',
    'escaleta37ap': '263373671',
    'escaleta37pb': '263373635',
    'escaleta610': '289260232',
    'esteira24': '266412023',
    'evidence200bk': '263048148',
    'f60bk': '263047892',
    'f60or': '263047861',
    'f60vi': '263047821',
    'fanfarra-pro-3': '264846992',
    'fd110': '267092991',
    'fd115': '267094618',
    'fd116': '267097906',
    'fd121': '267098577',
    'fd126': '267099824',
    'flautasgflb': '263373376',
    'fp10bk': '281117180',
    'fp10kit1': '284698919',
    'fp30xbk': '281154542',
    'fp30xbkit1': '284689528',
    'ft6418l': '398885414',
    'g30bk': '263048289',
    'g30or': '263048272',
    'gbs1': '262765389',
    'gd14cetos': '309660982',
    'gd37cepw': '309659467',
    'gd51cent': '309657992',
    'ge100': '263036373',
    'gl-10': '267006316',
    'gml300bk': '375482930',
    'gml600gt': '401743677',
    'grmn': '352434959',
    'gt-1': '284621265',
    'gt1200': '263223532',
    'gt150': '317241185',
    'gt300': '263227081',
    'gt3200': '400982351',
    'gt4200': '263223473',
    'gx-2': '267005713',
    'gy14etos': '309656797',
    'hk30872': '264103791',
    'hk57673': '264102483',
    'hk58859': '264102473',
    'hk65390': '264102520',
    'hk66070': '264102453',
    'hsp-c3300': '266408194',
    'joy': '399866388',
    'k382m': '263837368',
    'k402h': '380617669',
    'k492mr': '390023568',
    'k501m': '293605036',
    'kdsw402hh': '263837957',
    'kdsw402m': '263837688',
    'kdsw412m': '263838147',
    'kg745cb': '343373207',
    'kit1147': '291851644',
    'kit16bombeiros': '336897705',
    'kit45039': '402163823',
    'kit483tcsp': '400987185',
    'kitadahclassic': '269365897',
    'kitadahconcert': '264849263',
    'kitadahformal': '269479418',
    'kitadahmeed': '268670856',
    'kitcdppt': '345259843',
    'kitcdps110e': '264168352',
    'kitcdps110eb': '264167245',
    'kitcdps110ebx': '264169282',
    'kitcdps110sbc': '264165691',
    'kitcdps110sc': '264167669',
    'kitcdps110sct': '271874137',
    'kitcdps110sdb': '264166781',
    'kitcdps160c': '265764190',
    'kitcdps160cs46': '264671153',
    'kitcdps160cs46p': '264174760',
    'kitcdps160e': '264673378',
    'kitcdps160eb': '265759626',
    'kitcdps160s': '265761453',
    'kitcdps160sb': '265060146',
    'kitcdps160sbc': '265766131',
    'kitcdps160sc': '265062966',
    'kitcdps160sct': '273146923',
    'kitcdps160sd': '264859192',
    'kitcdps160sdb': '265762819',
    'kitcdps160sdbp': '264677566',
    'kitcdps160sdc': '264853637',
    'kitcdps360c': '264291586',
    'kitcdps360cs46': '264315166',
    'kitcdps360cs46b': '264315852',
    'kitcdps360cs46bpd': '257802764',
    'kitcdps360eb': '264298763',
    'kitcdps360s': '264295496',
    'kitcdps360sbc': '264289282',
    'kitcdps360sc': '264301677',
    'kitcdps360sct': '273170407',
    'kitcdps360sd': '264304012',
    'kitcdps360sdb': '264290627',
    'kitcdps360sdbc': '264308329',
    'kitcdps360sdc': '264305991',
    'kitcdps360sdpc': '264313760',
    'kitcdps360spc': '264303080',
    'kitcdps360wubt10': '269180469',
    'kitcs46b': '264419623',
    'kitcs46bx': '265772161',
    'kitcs46pb': '265773023',
    'kitcs46pbx': '265769943',
    'kitcs46pbxf': '265767556',
    'kitctk3500pedal2': '260988802',
    'kitctk3500sb': '261949177',
    'kitctk3500sp': '260987880',
    'kitcts1c': '262954889',
    'kitcts1rdc': '263097731',
    'kitcts1rds': '263095651',
    'kitcts1rdsb': '263101024',
    'kitcts1rdsc': '263050096',
    'kitcts1rdsp': '263101843',
    'kitcts1s': '262951747',
    'kitcts1sb': '262962865',
    'kitcts1sc': '262947257',
    'kitcts1sfakg': '280807572',
    'kitcts1sp': '262963586',
    'kitcts200bkc': '262757594',
    'kitcts200bks': '262761525',
    'kitcts200bksb': '262766730',
    'kitcts200bksbc': '262769016',
    'kitcts200bksc': '262764492',
    'kitcts200bksff': '262769928',
    'kitcts200bksp': '262767943',
    'kitcts200bkspc': '262770645',
    'kitcts200rdc': '262776723',
    'kitcts200rds': '262774793',
    'kitcts200rdsb': '262780600',
    'kitcts200rdsbc': '262915336',
    'kitcts200rdsc': '262778986',
    'kitcts200rdsff': '262916736',
    'kitcts200rdsp': '262781692',
    'kitcts200rdspc': '262918632',
    'kitcts200wesbc': '262930608',
    'kitcts200wesff': '262937558',
    'kitcts200whc': '262920546',
    'kitcts200whs': '262922828',
    'kitcts200whsb': '262927860',
    'kitcts200whsc': '262926741',
    'kitcts200whsp': '262929395',
    'kitcts200whspc': '262939455',
    'kitcts300ff': '260651893',
    'kitcts300s': '260828470',
    'kitcts300sb': '260787464',
    'kitcts300sbc': '260771933',
    'kitcts300sc': '260827726',
    'kitcts300sp': '260786460',
    'kitcts300spc': '260703016',
    'kitcts400c': '263351564',
    'kitcts400s': '263351003',
    'kitcts400sb': '263351950',
    'kitcts400sc': '263350796',
    'kitcts400sp': '263352203',
    'kitcts500c': '263354331',
    'kitcts500s': '263352770',
    'kitcts500sb': '263353235',
    'kitcts500sbc': '263354187',
    'kitcts500sc': '263353483',
    'kitctx3000s': '261561516',
    'kitctx3000sb': '261944051',
    'kitctx3000scp': '261940255',
    'kitctx800c': '260853529',
    'kitctx800s': '270358490',
    'kitctx800sb': '260978894',
    'kitctx800sc': '288953488',
    'kitctx800scp': '270357346',
    'kitctx800sff': '260857703',
    'kitdreamer12': '346713260',
    'kitdreamer16': '346592076',
    'kitdreamer18': '346724435',
    'kitew320sx': '343405316',
    'kitez300s': '264164990',
    'kitez300sb': '264166672',
    'kitez300sc': '264167696',
    'kitez300sf': '264163190',
    'kitez300sp': '264161567',
    'kitfanfarra': '264847470',
    'kitfanfarra16alm': '329491060',
    'kitfanfarra18': '329526118',
    'kitfanfarra24': '264847165',
    'kitfanfarragopinhob': '368601837',
    'kitfanfarrainfantil': '264846929',
    'kitfanfarraizzo24': '281034097',
    'kitfp10ebc': '318120192',
    'kitigreja10': '338438364',
    'kitigreja15': '338453753',
    'kitigrejaka': '355579574',
    'kitigrejakb': '354856855',
    'kitigrejakc': '357001973',
    'kitigrejaki': '355572954',
    'kitigrejasp': '346903407',
    'kitkaudioativo2': '353390956',
    'kitkaudioativoatrium12': '359913213',
    'kitkaudioativomc': '344528717',
    'kitlks250c': '263112099',
    'kitlks250s': '263131531',
    'kitlks250sb': '263136106',
    'kitlks250sbc': '263136936',
    'kitlks250sc': '263134353',
    'kitlks250sff': '263137566',
    'kitlks250sp': '263135370',
    'kitlks450s': '263266892',
    'kitlks450sb': '263271668',
    'kitlks450sc': '263260851',
    'kitlks450sp': '263272811',
    'kitmapu': '382644846',
    'kitmk-12ap': '375476516',
    'kitmk-15ap': '375764102',
    'kitp0029': '402031236',
    'kitp145bt': '382023140',
    'kitp145btl': '399034008',
    'kitp145bts': '382291445',
    'kitp145e': '265466382',
    'kitp145eb': '266030064',
    'kitp145ebp': '266030805',
    'kitp145s': '265464732',
    'kitp145sb': '265465163',
    'kitp145sbc': '265698778',
    'kitp145sbt': '382029659',
    'kitp145sp': '361499017',
    'kitp225e': '266032800',
    'kitp225ep': '266033059',
    'kitp225epb': '266033291',
    'kitp225s': '266031597',
    'kitp225sb': '266032070',
    'kitp225sbc': '266032379',
    'kitp515bep': '275895922',
    'kitp515ep': '276102723',
    'kitp515epb': '276097258',
    'kitpioneiro': '338917367',
    'kitps145bt': '382025913',
    'kitpsr-e283sc': '319850130',
    'kitpsre383c': '281066710',
    'kitpsre383s': '280372042',
    'kitpsre383sb': '281081138',
    'kitpsre383sbc': '281088768',
    'kitpsre383sc': '281044606',
    'kitpsre383scp': '281055158',
    'kitpsrf52s': '264000131',
    'kitpsrf52sb': '264000830',
    'kitpsrf52sc': '263999006',
    'kitpsrf52sff': '264001425',
    'kitpxs1100': '265202189',
    'kitpxs1100bc': '265353316',
    'kitpxs1100bke': '265376412',
    'kitpxs1100bksdb': '265374601',
    'kitpxs1100bksdc': '265371174',
    'kitpxs1100bksdct': '275412674',
    'kitpxs1100c': '265205237',
    'kitpxs1100eb': '265200084',
    'kitpxs1100rdc': '265360697',
    'kitpxs1100rde': '265377272',
    'kitpxs1100rds': '265359251',
    'kitpxs1100rdsdb': '265375547',
    'kitpxs1100rdsdc': '265362352',
    'kitpxs1100sbc': '265198908',
    'kitpxs1100sdbc': '265203459',
    'kitpxs1100whc': '265355933',
    'kitpxs1100whs': '265353935',
    'kitpxs1100whsdc': '265368026',
    'kitpxs3100sb': '265447278',
    'kitpxs3100sbc': '265451216',
    'kitpxs6000bke': '265458788',
    'kitpxs6000bkep': '265459452',
    'kitrepique': '400089242',
    'kitroland': '400998408',
    'kitsb': '278457542',
    'kitsc': '278456415',
    'kitsc46pbf': '265768939',
    'kitsenior': '338917350',
    'kitsuportecapa301': '278463019',
    'kittc361c': '263358547',
    'kittc361s': '263358641',
    'kittc361sc': '263358428',
    'kittc361sf': '263358759',
    'kittorcida': '264847740',
    'kittorcida2': '400013127',
    'kittorcida3': '400014167',
    'kitvorax1050max': '269560364',
    'kitvorax2100max0312': '269559201',
    'kitvorax630max': '269560414',
    'kkitpxs1100sb': '265197299',
    'kpd70bk': '352637656',
    'ks248sh': '361691546',
    'kscfp10-bk': '281126949',
    'kvlog2': '383296638',
    'kvlogp': '383300303',
    'l5514': '400079581',
    'lal4008tmagprv': '368590295',
    'lks250': '263110949',
    'lks450': '263226170',
    'lme5511tma': '399914304',
    'ma1030x': '364905242',
    'mapu2012': '382580551',
    'max500': '280457261',
    'mb40bks': '259823284',
    'mc8bt': '323489592',
    'mcb-c14200': '265931444',
    'mcjt-10310': '266406709',
    'me006416': '263373250',
    'me006801': '263373622',
    'me006802': '263373616',
    'me008214': '263373248',
    'me008215': '263373243',
    'me008460': '263373257',
    'mg30bk': '259823026',
    'mg30owh': '262762919',
    'mg30sb': '262762911',
    'mirach-tamb': '262762716',
    'mk-12a': '375462320',
    'mk-12p': '375469885',
    'mk-15a': '375625811',
    'mk-15a100': '399109990',
    'mk-15p': '375631565',
    'mk-8a': '375204570',
    'mm-120': '286723751',
    'mm113bastao': '263858315',
    'mm113lapela': '263838234',
    'mm120d': '308387387',
    'modenabk': '262761643',
    'montrealcb': '259822579',
    'montrealnt': '262761660',
    'mt39sndb': '403590940',
    'myth606': '287621368',
    'mythbk': '287871694',
    'mzx500': '268968659',
    'mzx500kit': '268969530',
    'mzx500kit2': '268976701',
    'newenglandgr': '300141856',
    'nu23mbq': '401049736',
    'nu23mlq': '318876354',
    'nu23mlqkit': '363528946',
    'opus14b': '267175728',
    'p-145bk': '265464462',
    'p-145bt': '379818299',
    'p-225bk': '266031091',
    'p0190': '267168929',
    'piano30pk': '278703837',
    'psr-e283sd': '367835049',
    'psr-e583': '391916668',
    'psre383': '280352018',
    'psse30': '288954017',
    'pssf30': '288953883',
    'pv1506rv': '368494963',
    'pv2006tmrvn': '368588566',
    'px5s': '267192561',
    'px5skit3': '267193135',
    'px5skit4': '267272634',
    'px5skit5': '267309714',
    'px770bn': '267489715',
    'px770we': '267489342',
    'pxs1100bk': '265049106',
    'pxs1100ebp': '265358111',
    'pxs1100rd': '265050157',
    'pxs1100we': '265046638',
    'pxs3100bk': '265446801',
    'pxs6000bk': '265457844',
    'pxs7000bk': '258775206',
    'pxs7000hme': '258775235',
    'qt4t': '400157318',
    'qtc5t': '400134590',
    'qtc6t': '400135018',
    'rackstudio': '263953590',
    'rc-1000': '400399389',
    'recoreco': '387774515',
    'ryu-natural': '342393039',
    's-250': '263377477',
    's14x14': '400157612',
    'sa46': '281146559',
    'sc120air': '267473462',
    'sca120ex': '267182004',
    'sca120in': '267473892',
    'sca96air': '267472994',
    'scan120': '267477363',
    'scan120l': '267476682',
    'scan120v': '267475976',
    'scan96': '267478087',
    'seductora64': '263377865',
    'sgpml': '277460593',
    'shogun-neo': '331387614',
    'sixmartbk': '262762741',
    'sixmartca': '262762685',
    'sk4069': '399125055',
    'slim2500g5': '340627666',
    'slim4700': '343018575',
    'sm90': '263837970',
    'sp33': '274471429',
    'sp34': '267481839',
    'spk-73rd': '331508029',
    'stationb': '379546235',
    'stella-dw-tblf': '262762820',
    'stm-80': '370966914',
    'supreme-ryu-mirai': '331494297',
    'sv-01': '263620570',
    'sw10': '340624440',
    'swellbkeq': '262762044',
    't-805owh': '262762856',
    't14x12': '400157141',
    't805bkdftt': '262762798',
    't805lpb': '262762754',
    't805sb': '262762763',
    't805trdlfpw': '262762779',
    'tal-04p': '269551383',
    'tbm4sb': '262765135',
    'tbm5sb': '262765125',
    'tbw-400': '399888501',
    'tc-261': '263356470',
    'tc261kit1': '263356622',
    'tc261kit2': '263356781',
    'tc261kit3': '263357059',
    'tc261kit4': '263357240',
    'tc361': '263358216',
    'tci-37': '278710897',
    'tg-500': '262762905',
    'tg500bk': '403589072',
    'tg500msg': '262762893',
    'tg500owh': '262762883',
    'tg500sb': '262762700',
    'tg500ve': '262762812',
    'tg530owh': '259823024',
    'tjb4bk': '262765142',
    'tokaid2bk': '268592224',
    'tokaid2br': '268590072',
    'tokaimd7br': '268596250',
    'tokaitp200c': '267456296',
    'tp315az': '263040403',
    'tq081': '269147453',
    'tw-61sb': '259823037',
    'tw55bs': '262762729',
    'ui24r': '263953794',
    'up115': '267480042',
    'v5514': '400079461',
    'va10sup': '288953240',
    've4420': '263375920',
    'vencedora80': '263377855',
    'vorax1050': '263048239',
    'vorax2100': '263048217',
    'vorax630': '263048259',
    'vorax840': '263047916',
    'vs14canhoto': '340296468',
    'wcmbb': '263373988',
    'wcmeb': '263373992',
    'wu-bt10': '269091812',
    'x16057': '263620918',
    'x46989': '348268189',
    'x49941': '263222980',
    'x50570': '262766163',
    'x50572': '262766222',
    'x50574': '262766216',
    'x50579': '363886228',
    'x52816': '264104713',
    'x54769': '263953615',
    'x54770': '263227009',
    'x54846': '281130453',
    'x55319': '263373356',
    'x55601': '263953511',
    'x55602': '263953492',
    'x58740': '263373314',
    'x59137': '263226999',
    'x59498': '264103800',
    'x59566': '262766134',
    'x59567': '363886238',
    'x60737': '262770430',
    'x60750': '262766608',
    'x60754': '262935050',
    'x61295': '263620752',
    'x61948': '263373288',
    'x62092': '263373350',
    'x62125': '263953465',
    'x62236': '267467484',
    'x63245': '363886285',
    'x63246': '363886308',
    'x63566': '363886325',
    'x63733': '363886356',
    'x63734': '363886732',
    'x63736': '363886378',
    'x64969': '262766190',
    'x64970': '262766176',
    'x65586': '267481190',
    'x65709': '262766091',
    'x65710': '262766041',
    'x65711': '262766085',
    'x65712': '363886393',
    'x65904': '264824790',
    'x66037': '262935033',
    'x66402': '262935015',
    'x66620': '263967736',
    'x67306': '268678958',
    'x67307': '268678937',
    'x68266': '281130767',
    'x68968': '283088681',
    'x69817': '263839109',
    'x69819': '263859847',
    'x69875': '268676380',
    'x70094': '277494846',
    'x70095': '267471016',
    'x70139': '263859469',
    'x70140': '263838250',
    'x70141': '263859432',
    'x70741': '281952840',
    'x71470': '263222990',
    'x71579': '275169439',
    'x72076': '401879504',
    'x72257': '263620670',
    'x72604': '262766171',
    'x72745': '267189855',
    'x72746': '267186687',
    'x72747': '267188456',
    'x72748': '267154274',
    'x72749': '267190887',
    'x72751': '267186059',
    'x72752': '267188135',
    'x72840': '263620828',
    'x72841': '263620773',
    'x73077': '277493491',
    'x73250': '264003622',
    'x73331': '262762876',
    'x73721': '264155151',
    'x73749': '262766181',
    'x73958': '263620709',
    'x74132': '281143153',
    'x74133': '281143328',
    'x75636': '263838741',
    'x75643': '263837341',
    'x75649': '263838278',
    'x75650': '263838483',
    'x75651': '263838701',
    'x75655': '263837918',
    'x75793': '263838226',
    'x75799': '263838261',
    'x75823': '263838449',
    'x76486': '264003959',
    'x76722': '268605290',
    'x76881': '267475873',
    'x76883': '371391297',
    'x77111': '278817019',
    'x77116': '267465885',
    'x78709': '267456045',
    'x79013': '263373190',
    'x79216': '262765147',
    'x79363': '262935468',
    'x79482': '263620500',
    'x79508': '400893296',
    'x79642': '267470380',
    'x79695': '354816830',
    'x80054': '263620537',
    'x80767': '363886412',
    'x80769': '363886448',
    'x80771': '363886469',
    'x81189': '363886486',
    'x81195': '363886507',
    'x81426': '355839855',
    'x81569': '263620521',
    'x82009': '267461095',
    'x82010': '267460938',
    'x82013': '266034034',
    'x82014': '266034532',
    'x83693': '355662276',
    'x83972': '355839808',
    'x83976': '319851094',
    'x84038': '375472300',
    'x84185': '343401063',
    'x85106': '400788214',
    'x85108': '375469066',
    'x85141': '355839603',
    'x85142': '355839621',
    'x85143': '355839633',
    'x85506': '355839744',
    'x85507': '355839749',
    'x85508': '355839752',
    'x85509': '355839758',
    'x85788': '363886524',
    'x85789': '363886591',
    'x85791': '363886650',
    'x85793': '363886689',
    'x86065': '355839804',
    'x86246': '355839852',
    'x87543': '402006103',
    'xb-21bk': '262765151',
    'xth101': '262766471',
    'ypt280': '361842112',
    'ypt280c': '362018218',
    'ypt280cp': '388378294',
    'ypt280cs': '362024838',
    'ypt280csp': '362041983',
    'ypt280s': '362019372',
    'ypt380': '362075010',
    'ypt380c': '362113214',
    'ypt380cp': '362685198',
    'ypt380cs': '362301879',
    'ypt380csp': '362689022',
    'ypt380p': '362211564',
    'ypt380s': '362308993',
    'ypt380sp': '362318327',
    'yw827bk': '325882676',
    'yw870bk': '325894327',
    'yw870rd': '325897251',
    'z5514': '400079395',
  };

  const normalize = (value) => String(value || '').trim().toLowerCase();
  const toNumber = (value) => {
    const number = Number(String(value || '').replace(',', '.'));
    return Number.isFinite(number) ? number : 0;
  };

  const renderRating = (element, rating) => {
    const rawAverage = toNumber(rating.average);
    const count = parseInt(rating.count, 10) || 0;
    const average = rawAverage > 0 && count > 0 ? rawAverage : 0;

    const percent = Math.max(0, Math.min(100, (average / 5) * 100));
    const averageLabel = average.toFixed(1).replace('.', ',');

    element.style.setProperty('--trustvox-rating-percent', `${percent}%`);
    element.setAttribute('role', 'img');
    element.setAttribute('aria-label', count > 0 ? `${averageLabel} de 5 estrelas em ${count} avaliações` : 'Sem avaliações');
    element.innerHTML = `<span class="product-card__trustvox-stars" aria-hidden="true"></span><span class="product-card__trustvox-count" aria-hidden="true">(${count})</span>`;
    element.hidden = false;
  };

  const loadRates = (codes, callback) => {
    const callbackName = `superSonoraTrustvox${Date.now()}${Math.round(Math.random() * 100000)}`;
    const script = document.createElement('script');
    const params = codes.map((code) => `codes[]=${encodeURIComponent(code)}`);

    params.push(`store_id=${encodeURIComponent(storeId)}`);
    params.push(`callback=${encodeURIComponent(callbackName)}`);

    window[callbackName] = (response) => {
      callback(response);
      delete window[callbackName];
      script.remove();
    };

    script.onerror = () => {
      callback({ products_rates: [] });
      delete window[callbackName];
      script.remove();
    };

    script.src = `https://trustvox.com.br/widget/shelf/v2/products_rates?${params.join('&')}`;
    document.head.appendChild(script);
  };

  const init = (root) => {
    const elements = Array.from(root.querySelectorAll('.product-card__trustvox-rating:not([data-trustvox-loaded])'));
    const byCode = new Map();

    elements.forEach((element) => {
      const sku = normalize(element.dataset.trustvoxProductSku);
      const code = normalize(element.dataset.trustvoxProductCode) || skuToCode[sku];
      const fallbackAverage = toNumber(element.dataset.reviewRating);
      const fallbackCount = parseInt(element.dataset.reviewCount, 10) || 0;

      element.dataset.trustvoxLoaded = 'true';
      renderRating(element, { average: fallbackAverage, count: fallbackCount });

      if (code) {
        element.dataset.trustvoxResolvedCode = code;
        if (!byCode.has(code)) byCode.set(code, []);
        byCode.get(code).push(element);
      }
    });

    const codes = Array.from(byCode.keys());
    if (!codes.length) return;

    loadRates(codes, (response) => {
      const rates = response && Array.isArray(response.products_rates) ? response.products_rates : [];
      const rateByCode = new Map(rates.map((rate) => [normalize(rate.product_code), rate]));

      byCode.forEach((containers, code) => {
        containers.forEach((container) => {
          const rate = rateByCode.get(code);
          const fallbackAverage = toNumber(container.dataset.reviewRating);
          const fallbackCount = parseInt(container.dataset.reviewCount, 10) || 0;

          if (rate && toNumber(rate.average) > 0 && parseInt(rate.count, 10) > 0) {
            renderRating(container, rate);
          } else if (fallbackAverage > 0 && fallbackCount > 0) {
            renderRating(container, { average: fallbackAverage, count: fallbackCount });
          } else {
            renderRating(container, { average: 0, count: 0 });
          }
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
